import { deleteDocument, getCollectionRef } from "./basicOperations";

const deleteDocumentbyID = async (collection, docId) => {
  const collectionRef = await getCollectionRef(collection);
  await deleteDocument(collectionRef, docId);
};

export default deleteDocumentbyID;
